import { ProfilePanel } from '@/pages/Profile';

export default function ProfileApp() {
  return <ProfilePanel embedded />;
}
